const SET_DATES = (state, dates) => {
	state.dates = dates
}

const ADD_DATE = (state, date) => {
	state.dates.unshift(date)
}

const SET_COMMITTEES = (state, committees) => {
	state.committees = committees
}

const SET_PROTOCOL_REVIEWERS = (state, reviewers) => {
	state.reviewers = reviewers
}

const SET_DICTUM_TYPES = (state, dictumTypes) => {
	state.dictumTypes = dictumTypes
}

const SET_DICTUMS = (state, dictums) => {
	state.dictums = dictums
}

const SET_COMMITEE_DICTUMS = (state, dictums) => {
	state.committeeDictums = dictums
}

const SET_ASSIGNED_REVIEWERS = (state, assignedReviewers) => {
	state.assignedReviewers = assignedReviewers
}

const SET_ASSIGNED_REVIEWER_DICTUMS = (state, assignedReviewerDictums) => {
	state.assignedReviewerDictums = assignedReviewerDictums
}

const SET_PROTOCOL_TASK_ADVANCE = (state, protocolTaskAdvance) => {
	state.protocolTaskAdvance = protocolTaskAdvance
}

export default {
	SET_DATES,
	SET_COMMITTEES,
	SET_PROTOCOL_REVIEWERS,
	SET_DICTUM_TYPES,
	SET_DICTUMS,
	SET_COMMITEE_DICTUMS,
	ADD_DATE,
	SET_ASSIGNED_REVIEWERS,
	SET_ASSIGNED_REVIEWER_DICTUMS,
	SET_PROTOCOL_TASK_ADVANCE,
}
